import { computeBoundsFromGeometry, finishFrameBounds } from './styleRegion';
export const computeBounds = (region, geometry) => {
    // Compute world space bounds.
    const bounds = computeBoundsFromGeometry(region, geometry);
    // Finish frame bounds.
    finishFrameBounds(region, bounds);
    return bounds;
};
